import { setGA4Event } from "@iewccouk/Store/Handlers/Utilities/CustomTracking";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    CreateDataForUnparse,
    GenerateCsv,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import translate from "@insite/client-framework/Translate";

/* Verndale Custom Feature - Replace chain to set first CSV column based on CMI condition */
replaceInChain(chain, CreateDataForUnparse, props => {
    const { wishListLineCollection } = props.apiResult;
    if (!wishListLineCollection?.length) {
        return;
    }

    props.dataForUnparse = {
        fields: [
            translate("Item #"),
            translate("MFG #"),
            translate("Quantity"),
            translate("Unit of Measure"),
            translate("Brand"),
            translate("Title"),
            translate("Price"),
            translate("Notes"),
            translate("Added on"),
            translate("Added by"),
        ],
        data: wishListLineCollection.map(o => {
            const isCmiProduct = (o.properties["isCmiProduct"] ?? "").toLowerCase() === "true";
            return [
                isCmiProduct ? o.properties["modelNumber"] : o.erpNumber,
                o.manufacturerItem,
                o.qtyOrdered.toString(),
                o.unitOfMeasure,
                o.brand?.name || "",
                o.shortDescription,
                o.quoteRequired ? "" : o.pricing?.unitRegularPrice?.toString() || "",
                o.notes,
                o.createdOn.toString(),
                o.createdByDisplayName,
            ];
        }),
    };
});

// Verndale Customization - Add GA4 event tracking for Export
replaceInChain(chain, GenerateCsv, async props => {
    const state = props.getState();
    const pageTitle = getCurrentPage(state).fields.title;

    if (!props.dataForUnparse) {
        return;
    }

    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");
    const csv = unparse(props.dataForUnparse);
    const csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });

    const fileName = `wishlist_${props.parameter.wishListId}.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(csvBlob);
    downloadLink.setAttribute("download", fileName);
    downloadLink.click();

    setGA4Event([], "sap_file_download", {
        file_name: fileName,
        file_extension: fileName.split(".").pop(),
        link_text: "Export",
        link_url: downloadLink.href,
        pageTitle,
    });
});
